module.exports = "/_next/static/images/inquirer-423915aa401569dc9f948c0857244152.svg";